import React, { useContext, useState } from 'react'
import firebase from 'firebase/app'
import 'firebase/firestore'
import { DataContext } from '../../../providers/dataProvider'


const DatabaseConstruction = () => {
  const [moreInfo, setMoreInfo] = useState({});
  const { constructions } = useContext(DataContext);
  const constructionsRef = firebase.firestore().collection('constructions')

  const [edit, setEdit] = useState({})

  const toggleEditShow = (id) => {
      setEdit(constructions.find((item) => item.id == id))
      setMoreInfo((prevMoreInfo) => ({
         [id]: !prevMoreInfo[id],
      }));
  };

  function sortItems(a, b) {
   if (a.price < b.price) {
     return -1;
   }
   if (a.price > b.price) {
     return 1;
   }
   return 0;
 }
//   const [newPrice, setNewPrice] = useState()

//   const handlePriceChange = (itemeId) => {
//     const model = constructions.find((item) => item.id == itemeId).model
//     console.log(model, newPrice)
//     console.log(constructionssRef.doc(itemeId).price)
//   }

  const constructionssList = constructions
   .sort(sortItems)
   .map((item) => {
    return (
      <>
        <tr
         
         className="container"
        >
         <td className="col m-2">{item.type}</td>
         <td className="col m-2">{item.price} zł</td>
         <td className='col'>
            <button
               className='btn btn-outline-primary btn-sm'
               onClick={() => {
                  toggleEditShow(item.id);
                }}>
                  edytuj
            </button>
         </td>
         {/* <td className='col'>
            <button
               className='btn btn-outline-danger btn-sm'>
                  usuń
            </button>
         </td> */}
        </tr>
        {moreInfo[item.id] ? (
         <tr>
            <td>
               {/* <input type="number" 
                  className='form-control form-control-sm'
                  onChange={(e) => setEdit({...edit, type: e.target.value})}
                  value={edit.price}/> */}
            </td>
            <td>
               <input type="number" 
                  className='form-control form-control-sm'
                  onChange={(e) => setEdit({...edit, price: 1*e.target.value})}
                  value={edit.price}/>
            </td>
            <td>
               <button className='btn btn-outline-success'
                  onClick={() => {constructionsRef.doc(item.id).set(edit)
                    toggleEditShow(item.id);
                     }}
               >aktualizuj</button>
            
               <button className='btn btn-outline-secondary'
                  onClick={() => {
                     toggleEditShow(item.id);
                   }}
               >anuluj</button>
            </td>
         </tr>
        ) : null}
      </>
    );
  });

  return (
    <>
      {/* <AddToFirestore collection="constructions" /> */}
      <table className="table table-striped table-hover w-auto mx-auto">
        <thead>
          <tr>
          {/* <th scope="col">TYP</th> */}
          {/* <th scope="col">MOC - OD</th> */}
          <th scope="col">TYP</th>
          <th scope="col">CENA</th>
          <th scope='col'></th>
          </tr>
        </thead>
        <tbody>{constructionssList}</tbody>
      </table>
    </>
  );
};

export default DatabaseConstruction;
